import { InjectionToken } from "@angular/core";
import { ILauncherService } from "./i-launcher.service";

export const launcherServiceInjectionToken: InjectionToken<ILauncherService> = new InjectionToken<ILauncherService>("digital-signage.developer-dashboard.LauncherService");
